export const transformPastedHTML = (html: string) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  replaceTrailingSpacesWithNonBreakingSpaces(doc.body);

  return doc.body.innerHTML;
};

const replaceTrailingSpacesWithNonBreakingSpaces = (node: ChildNode) => {
  node.childNodes.forEach(child => {
    if (child.nodeType === Node.TEXT_NODE) {
      if (child?.nodeValue?.startsWith(' ')) {
        child.nodeValue = child.nodeValue.replace(/^\s+/g, match => match.replace(/ /g, '\u00A0'));
      }
    } else if (child.nodeType === Node.ELEMENT_NODE) {
      replaceTrailingSpacesWithNonBreakingSpaces(child);
    }
  });
};
